<!-- 主页全局配置 -->
<template>
	<div>
		<el-container style="position: absolute;left: 0; top: 0; bottom: 0;right: 0;">
			<!-- 顶部导航 -->
			<el-header class="d-flex align-items-center" style="background: #ffffff;">
				<div class="d-flex align-items-center" style="margin-left: 10px;width: 240px;">
					<img src="@/image/qklogo.png" style="width: 28px;height: 28px;border-radius: 10px;" />
					<div style="font-size: 15px;margin-left: 8px;font-weight: 800;color: #22449b;">诚晖仓库管理系统</div>
				</div>
				<div style="display: flex;justify-content: flex-end;width: 100%;">
					<div class="d-flex align-items-center ml-2 mr-2">
						<img :src="user.avatar ? user.avatar : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"
							style="width: 20px;height: 20px;border-radius: 20px;">
						<div style="font-size: 14px;color: #8a8a8a;margin-left: 5px;">{{ user.name }}</div>
					</div>
					<div class="btn el-icon-refresh-right" @click="goback(0)"></div>
					<div class="btn el-icon-switch-button" @click="goback(1)"></div>
				</div>
				
			</el-header>

			<!-- 内容 -->
			<el-container style="height: 100%;">
				<!-- 左边布局 -->
				<el-aside :style="{  width: kzan == 1 ? '140px': '60px' }">
					<el-menu
						:default-active="navBar.active"
						@select="handleSelect"
						style="height: 100%;background-color: #ffffff;"
						class="el-menu-vertical-demo"
					>
						<el-menu-item style="height: 50px;line-height: 50px;" :index="index | numToString" v-for="(item, index) in navBar.list" :key="index">
							<i :class="item.icon"></i>
							<span :style="{  display: kzan == 1 ? '': 'none' }">{{ item.name }}</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-aside width="140px" style="height: 92%;" :style="{  display: kzan == 1 ? '': 'none' }">
					<el-menu :default-active="slideMenuActive" @select="slideSelect" class="el-menu-vertical-demo">
						<el-menu :default-active="slideMenuActives" @select="slideSelects" class="el-menu-vertical-demo" :default-openeds="['0','1','2','3']"
							@open="handleOpen" @close="handleClose" >
							<el-submenu :index="indexa | numToString" v-for="(item,indexa) in slideMenus" :key="indexa">
								<template slot="title" class="">
									<i class="el-icon-plus" style="margin-left: -10px;color: #22449b;"></i>
									<span style="font-weight: 800;color: #22449b;">{{item.name}}</span>
								</template>
								<el-menu-item :index="chi[indexa].toString()+'-'+chi[indexs].toString()" v-for="(e,indexs) in item.child" :key="indexs" style="min-width: 0;padding-left: 20px;height: 50px;line-height: 50px;" @click="gotos(e.pathname)">
									<i :class="e.icon"></i>
									<span>{{e.name}}</span>
								</el-menu-item>
							</el-submenu>
						</el-menu>
					</el-menu>
				</el-aside>
				<div style="height: 100%;width: 20px;box-shadow:inset 0px 15px 10px -15px #cecece;" class="d-flex bg-light">
					<div style="width: 40px;height: 60px;justify-content: center;margin-top: 300px;" class="d-flex align-items-center">
						<div style="border-radius: 0px 40px 40px 0;width: 100%;height: 50%;background-color: #ffffff;justify-content: center;" class="d-flex align-items-center" @click="kzanbut">
							<div>{{kzan == 1 ? '<' : '>'}}</div>
						</div>
						
					</div>
				</div>
				<!-- 右边布局 -->
				<el-main class="bg-light" style="padding-bottom: 60px;position: relative;overflow: hidden;box-shadow:inset 0px 15px 10px -15px #cecece;" v-loading="loading">
					<!-- 面包屑导航 -->
					<div class="border-bottom mb-3 bg-white" style="padding: 20px; margin-left: -20px;" v-if="bran.length > 0">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: item.path }" v-for="(item, index) in bran" :key="index">{{ item.title }}</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<!-- 主内容 -->
					<router-view></router-view>

					<!-- 回到顶部 -->
					<el-backtop target=".el-main" :bottom="100">
						<div
							style="{height: 100%;width: 100%;
							background-color: #f2f5f6;
							box-shadow: 0 0 6px rgba(0,0,0, .12);
							text-align: center;
							line-height: 40px;
							color: #1989fa;}"
						>
							UP
						</div>
					</el-backtop>
				</el-main>
			</el-container>
		</el-container>
		<!-- <router-view></router-view> -->
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common],
	provide() {
		return {
			layout: this
		};
	},
	data() {
		return {
			bran: [],
			loading: false,
			chi:[0,1,2,3,4,5,6,7,8],
			indexs:'0',
			kzan:1
		};
	},
	created() {
		// 获取面包屑导航
		this.getRouterBran();
		// 初始化选中菜单
		this.__initNavBar();
		// console.log(this.navBar)
	},
	// 页面监听器
	watch: {
		$route(to, from) {
			this.navBar.list.forEach((item, index) => {
				item.submenu.forEach((x,indexs)=>{
					let i = x.child.findIndex(v => v.pathname === to.name);
					if (i !== -1) {
						// console.log('页面监听1',indexs)
						this.navBar.active = index.toString();
						this.indexs = indexs.toString();
						this.slideMenuActive = indexs.toString();
						this.slideMenuActives = indexs.toString()+'-'+i.toString();
					}
				})
			});
			// console.log('页面监听2',this.slideMenuActive)
			// console.log('页面监听3',this.slideMenuActives)
			// 本地存储
			localStorage.setItem(
				'navActive',
				JSON.stringify({
					top: this.navBar.active || '0',
					left: this.slideMenuActive || '0',
					lefts: this.slideMenuActives || '0'
				})
			);
			this.getRouterBran();
		}
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user,
			navBar: state => state.menu.navBar
		}),
		slideMenuActive: {
			get() {
				let item = this.navBar.list[this.navBar.active];
				return item ? this.indexs : '0';
			},
			set(val) {
				let item = this.navBar.list[this.navBar.active];
				// console.log(99,val)
				if (item) {
					item.subActive = val;
				}
			}
		},
		slideMenuActives: {
			get() {
				let item = this.navBar.list[this.navBar.active];
				return item ? item.subActive : '0';
			},
			set(val) {
				let item = this.navBar.list[this.navBar.active];
				if (item) {
					item.subActive = val;
				}
			}
		},
		slideMenus() {
			let item = this.navBar.list[this.navBar.active];
			return item ? item.submenu : [];
		}
	},
	// 点击导航获得索引
	methods: {
		handleOpen(key, keyPath) {
			// console.log('三级标签',key, keyPath);
		},
		handleClose(key, keyPath) {},
		// 显示loading
		showLoading() {
			this.loading = true;
		},
		// 隐藏loading
		hideLoading() {
			this.loading = false;
		},
		// 获取本地存储
		__initNavBar() {
			let r = localStorage.getItem('navActive');
			if (r) {
				r = JSON.parse(r);
				this.navBar.active = r.top;
				this.slideMenuActive = r.left;
				this.slideMenuActives = r.lefts;
			}
		},
		// 获取面包屑导航
		getRouterBran() {
			let b = this.$route.matched.filter(v => v.name);
			let arr = [];
			b.forEach((v, k) => {
				// 过滤layout和index
				if (v.name === 'index' || v.name === 'layout') return;
				arr.push({
					name: v.name,
					path: v.path,
					title: v.meta.title,
					icon: v.icon
				});
			});
			if (arr.length > 0) {
				arr.unshift({
					name: 'index',
					path: '/index',
					title: '后台首页'
				});
			}
			this.bran = arr;
		},
		// 顶部导航
		handleSelect(key, keyPath) {
			this.navBar.active = key;
			// 默认选中跳转到当前激活
			this.slideMenuActive = '0';
			this.slideMenuActives = '0';
			if (this.slideMenus.length > 0) {
				this.$router.push({
					name: this.slideMenus[this.slideMenuActive].pathname
				});
			}
			this.kzan = 1
		},
		goback(e){
			if(e == 0){
				this.$router.go(0)
			}else{
				this.logout()
			}
		},
		gotos(e){
			this.$router.push({
				name: e
			});
		},
		slideSelect(key, keyPath) {
			// console.log(888,key, keyPath)
			this.slideMenuActive = key;
			// 跳转到指定页面
			this.$router.push({
				name: this.slideMenus[key].pathname
			});
		},
		slideSelects(key, keyPath) {
			// console.log(999,key, keyPath)
			this.slideMenuActives = key;
			// 跳转到指定页面
			// this.$router.push({
			// 	name: this.slideMenus[key].pathname
			// });
		},
		// 退出登录
		logout() {
			this.axios
				.post(
					'/admin/logout',
					{},
					{
						token: true,
						loading: true
					}
				)
				.then(res => {
					this.$message('退出成功');
					// 清除状态和存储
					this.$store.commit('logout');
					// 返回到登录页
					this.$router.push({
						name: 'login'
					});
				})
				.catch(err => {
					// console.log(err.response);
					// 清除状态和存储
					this.$store.commit('logout');
					// 返回到登录页
					this.$router.push({
						name: 'login'
					});
				});
		},
		kzanbut(){
			if(this.kzan == 1){
				this.kzan = 0
			}else{
				this.kzan = 1
			}
		}
	}
};
</script>

<style>
.leftbuju {
	color: #ffffff;
}
.leftbuju:hover {
	color: #1f2138;
}

.el-menu-item, .el-submenu__title{
	height: 53px;
	line-height: 53px;
}
.el-menu{
	border-right: 0;
}
.el-menu-item.is-active {
    color: #22449b;
    border-right: 2px solid #22449b;
	background: #d9e7ff;
}
</style>

